import React from 'react';
import {Row, Col, Card} from 'antd';

import SuccessPieChart from './SuccessPieChart';
import TestUsage from './TestUsage';
import CompletionOverTimeChart from './CompletionOverTimeChart';

interface ReviewInterface {
}

const Review: React.FC<ReviewInterface> = ({}) => (
    <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
            <Card size='small'>
                <SuccessPieChart/>
            </Card>
        </Col>
        <Col xs={24} md={12}>
            <Card size='small'>
                <TestUsage/>
            </Card>
        </Col>
        <Col xs={24} md={12}>
            <Card size='small'>
                <CompletionOverTimeChart/>
            </Card>
        </Col>
    </Row>
);

export default Review;
